const IMAGE_WIDTHS = [320, 480, 640, 768, 960, 1280, 1440, 1600, 2048];
const API_PREFIX = "/api/v1";
function uploadUrl(storageKey, origin = "") {
  return `${origin}${API_PREFIX}/uploads/${storageKey}`;
}
function imageUrl(storageKey, width, origin = "") {
  return `${origin}${API_PREFIX}/img/${storageKey}?w=${String(width)}`;
}

export { API_PREFIX, IMAGE_WIDTHS, imageUrl, uploadUrl };
//# sourceMappingURL=media-urls.js.map
//# sourceMappingURL=media-urls.js.map